export default __webpack_public_path__ + "static/media/nsfLogo.eb5f9c3c.png";